import { z } from 'zod'

// Custom photo upload for recipes & activities. Images are downscaled and
// re-encoded to JPEG on-device, so uploads are small; the server still
// re-checks the decoded byte length and sniffs the magic bytes — never trust
// the client-declared content type or size.

// Content types the server will store. The on-device downscaler always emits
// JPEG; PNG/WEBP are here so a future direct-upload path (or a different
// encoder) still parses. The stored S3 ContentType comes from a magic-byte
// sniff, not this value.
export const ImageContentType = z.enum([
	'image/jpeg',
	'image/png',
	'image/webp',
])
export type ImageContentType = z.infer<typeof ImageContentType>

// Decoded cap. A streamed image is base64'd into the Lambda response (~4/3
// expansion) under a hard 6MB limit; 2MB decoded ⇒ ~2.8MB body, comfortably
// under. Downscaled phone photos are 150–500KB anyway.
export const MAX_IMAGE_BYTES = 2 * 1024 * 1024

// Base64 payload with no `data:…;base64,` prefix. The `.max` is a cheap first
// gate on the encoded string; the handler re-checks the decoded byteLength.
export const ImageUploadBody = z.object({
	data: z.base64().max(4 * Math.ceil(MAX_IMAGE_BYTES / 3)),
	contentType: ImageContentType,
})
export type ImageUploadBody = z.infer<typeof ImageUploadBody>
